var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIdentification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 41,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.661 38.124c0 1.181-16.16 2.138-36.096 2.138C16.63 40.262.47 39.305.47 38.124c0-1.18 16.16-2.137 36.096-2.137 19.936 0 36.096.957 36.096 2.137",
    fill: "#C3F1E3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.107 36.56H9.167a2.976 2.976 0 01-2.976-2.973V3.63A2.975 2.975 0 019.167.656h53.94a2.974 2.974 0 012.976 2.974v29.957a2.975 2.975 0 01-2.976 2.974z",
    stroke: "#076447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.908 31.431H12.565a1.24 1.24 0 01-1.24-1.239V7.024a1.24 1.24 0 011.24-1.239h16.343c.686 0 1.24.555 1.24 1.24v23.167a1.24 1.24 0 01-1.24 1.24",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.908 31.431H12.565a1.24 1.24 0 01-1.24-1.239V7.024a1.24 1.24 0 011.24-1.239h16.343c.686 0 1.24.555 1.24 1.24v23.167a1.24 1.24 0 01-1.24 1.24z",
    stroke: "#076447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.173 17.463H49.459a1.487 1.487 0 01-1.488-1.487V8.691c0-.821.666-1.487 1.488-1.487h10.714c.822 0 1.488.666 1.488 1.487v7.285c0 .822-.666 1.487-1.488 1.487",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.173 17.463H49.459a1.487 1.487 0 01-1.488-1.487V8.691c0-.821.666-1.487 1.488-1.487h10.714c.822 0 1.488.666 1.488 1.487v7.285c0 .822-.666 1.487-1.488 1.487z",
    stroke: "#076447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3F1E3",
    d: "M52.249 17.463h5.133V7.205H52.25z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#076447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M52.249 17.463h5.133V7.205H52.25zM57.383 11.48h4.278M47.971 13.189h4.278M34.57 7.495h5.305M34.57 10.914h5.305M34.57 27.012h6.305M34.57 30.431h8.305M50.682 27.012h9.412M50.682 30.431h7.412M34.57 17.044h9.123M34.57 20.463h9.123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.87 16.044a5.131 5.131 0 01-5.133 5.129 5.13 5.13 0 01-5.134-5.13 5.13 5.13 0 015.134-5.129 5.131 5.131 0 015.133 5.13",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.87 16.044a5.131 5.131 0 01-5.133 5.129 5.13 5.13 0 01-5.134-5.13 5.13 5.13 0 015.134-5.129 5.131 5.131 0 015.133 5.13z",
    stroke: "#076447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.126 30.12c-.24-4.98-4.345-8.947-9.39-8.947-5.043 0-9.148 3.967-9.388 8.947.061.731.656 1.311 1.403 1.311h15.97c.749 0 1.344-.58 1.405-1.31",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.126 30.12c-.24-4.98-4.345-8.947-9.39-8.947-5.043 0-9.148 3.967-9.388 8.947.061.731.656 1.311 1.403 1.311h15.97c.749 0 1.344-.58 1.405-1.31z",
    stroke: "#076447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconIdentification;